import { Controller } from '@hotwired/stimulus';

export default class ApexChartsPriceController extends Controller {
  static targets = ['chart'];
  static values = {
    series: Array,
    seriesName: String,
    yaxisTitle: String,
    yaxisFormatter: String,
  };

  connect() {
    const priceData = this.seriesValue;
    const values = priceData.map((x) => x[1]);
    const minValue = Math.min.apply(Math, values);
    const maxValue = Math.max.apply(Math, values);

    window.Apex = {
      chart: {
        height: 240,
        toolbar: {
          show: true,
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
          },
        },
        animations: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      stroke: {
        width: 3,
        curve: 'smooth',
      },
      grid: {
        row: {
          colors: ['transparent', 'transparent'],
          opacity: 0.2,
        },
        borderColor: '#f1f3fa',
      },
      xaxis: {
        type: 'datetime',
      },
      tooltip: {
        x: {
          formatter: function (n) {
            let d = new Date(n);
            return new Date(
              d.getFullYear(),
              d.getMonth(),
              d.getDate(),
            ).toLocaleDateString(document.documentElement.lang);
          },
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              toolbar: {
                show: false,
              },
            },
            legend: {
              show: true,
            },
          },
        },
      ],
    };

    const options = {
      chart: {
        type: 'line',
      },
      series: [
        {
          name: this.seriesNameValue,
          data: priceData,
        },
      ],
      yaxis: {
        forceNiceScale: true,
        labels: {
          formatter: (val) => {
            if (this.yaxisFormatterValue === 'currency') {
              return val.toLocaleString(document.documentElement.lang) + ' €';
            }
            return val.toLocaleString(document.documentElement.lang);
          },
        },
        title: {
          text: this.yaxisTitleValue,
        },
        min: minValue * 0.95,
        max: maxValue * 1.05,
      },
    };

    this.chart = new ApexCharts(this.chartTarget, options);
    this.chart.render();
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
}
